export default {
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
